import type { PluginInstallation } from '@/shared/api/types/plugins';
import i18n from '@/shared/i18n';

export function pluginStateLabel(state: PluginInstallation['state'] | undefined) {
  return i18n.t(`states.${state ?? 'Empty'}`, { ns: 'plugins', lng: 'de' });
}
export function pluginActionLabel(action: string) {
  return i18n.t(`actions.${action}`, { ns: 'plugins', lng: 'de', defaultValue: action });
}
export function pluginCapabilityLabel(capability: string) {
  return i18n.t(`capabilities.${capability}`, {
    ns: 'plugins',
    lng: 'de',
    defaultValue: capability,
  });
}
export function parsePluginSearch(search: Record<string, unknown>) {
  return { tab: search.tab === 'team' || search.tab === 'connection' ? search.tab : 'overview' };
}
export function parsePluginLinkSearch(search: Record<string, unknown>) {
  return {
    linkId: typeof search.linkId === 'string' ? search.linkId : '',
    nonce: typeof search.nonce === 'string' ? search.nonce : '',
    state: typeof search.state === 'string' ? search.state : '',
  };
}
